import { render, staticRenderFns } from "./AddLegalPartnerModal.vue?vue&type=template&id=08444704&scoped=true"
import script from "./AddLegalPartnerModal.vue?vue&type=script&lang=js"
export * from "./AddLegalPartnerModal.vue?vue&type=script&lang=js"
import style0 from "./AddLegalPartnerModal.vue?vue&type=style&index=0&id=08444704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08444704",
  null
  
)

export default component.exports